// Cross-browser confirm — window.confirm() bazı Chrome sürümlerinde bloklanıyor,
// bu yüzden shadcn AlertDialog kullanan hook-based confirm sağlıyoruz.
import { createContext, useCallback, useContext, useState } from "react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";

const ConfirmContext = createContext(null);

export function ConfirmProvider({ children }) {
  const [state, setState] = useState(null);

  const confirm = useCallback((opts) => new Promise((resolve) => {
    const o = typeof opts === "string" ? { message: opts } : (opts || {});
    setState({
      title: o.title || "Onaylıyor musunuz?",
      message: o.message || "Bu işlem geri alınamaz.",
      confirmText: o.confirmText || "Evet, Sil",
      cancelText: o.cancelText || "Vazgeç",
      destructive: o.destructive !== false, // default true
      resolve,
    });
  }), []);

  const close = (result) => {
    if (state?.resolve) state.resolve(result);
    setState(null);
  };

  return (
    <ConfirmContext.Provider value={confirm}>
      {children}
      <AlertDialog open={!!state} onOpenChange={(o) => { if (!o) close(false); }}>
        <AlertDialogContent data-testid="confirm-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle data-testid="confirm-title">{state?.title}</AlertDialogTitle>
            <AlertDialogDescription data-testid="confirm-message" className="whitespace-pre-line">
              {state?.message}
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="confirm-cancel" onClick={() => close(false)}>
              {state?.cancelText}
            </AlertDialogCancel>
            <AlertDialogAction
              data-testid="confirm-ok"
              onClick={() => close(true)}
              className={state?.destructive ? "bg-red-600 hover:bg-red-700 text-white" : ""}
            >
              {state?.confirmText}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </ConfirmContext.Provider>
  );
}

export function useConfirm() {
  const ctx = useContext(ConfirmContext);
  if (!ctx) {
    // Fallback for components rendered outside provider
    return async (opts) => {
      const msg = typeof opts === "string" ? opts : (opts?.message || "Onaylıyor musunuz?");
      return window.confirm(msg);
    };
  }
  return ctx;
}
